module.exports = __webpack_public_path__ + "media/images/emblems/Corgemont-coat_of_arms-3e37a0579262b127b8e7f120fae9a736.svg";